module.exports = __webpack_public_path__ + "img/bg-diagnostico.4440c985.jpg";